import { CURRENT_YEAR } from '@vizit/constants';

function AuthFooter() {
  return <footer className="text-sm text-gray-dark-500 py-4">©{CURRENT_YEAR} Vizit Labs, Inc</footer>;
}

export { AuthFooter };
